import type { BorderStyledProps, ColorStyledProps } from '@viewup/ui';
import { Edit, Flag, Note } from '@viewup/ui';
import type { ProgressIconColor, ProgressIconStatus, ProgressIconType } from './ProgressIcon';

export const ICON_MAP: Record<ProgressIconType, typeof Edit | typeof Flag | typeof Note> = {
  apply: Note,
  edit: Edit,
  submit: Flag,
} as const;

export const getStatusStyles = (
  color: ProgressIconColor = 'info',
): Record<
  ProgressIconStatus,
  {
    bgColor: ColorStyledProps['bgColor'];
    border: BorderStyledProps['border'];
    color: ColorStyledProps['color'];
  }
> => ({
  disable: {
    bgColor: 'bg.tertiary',
    border: undefined,
    color: 'icon.disabled',
  },
  done: {
    bgColor: `bg.${color}Subtle`,
    border: `1 solid border.${color}`,
    color: `icon.${color}`,
  },
  final: {
    bgColor: `bg.${color}Subtle`,
    border: `1 solid border.${color}`,
    color: `icon.${color}`,
  },
  inProgress: {
    bgColor: `bg.${color}Subtle`,
    border: `1 dashed border.${color}`,
    color: `icon.${color}`,
  },
  notStarted: {
    bgColor: 'bg.tertiary',
    border: '1 dashed border.info',
    color: 'icon.disabled',
  },
});
